import React, { FC } from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';

import WizardForm from '~/components/WizardForm';
import { useGetPayload } from '~/controllers/wizard';
import { Stage } from '~/types/Application';
import { Draft } from '~/types/Draft';
import { managersGetFormName } from '~/pages/ksa/application/managers/components/ManagerEdit';
import { Form } from '~/components';
import ManagersReviewTableForm from '~/pages/ksa/review/managers/components/ManagersReviewTableForm';
import {
  reviewManagersGetFormName,
  reviewManagersFormName,
} from '~/pages/ksa/review/managers/components/ManagerReviewEdit';
import StepReviewComment from '~/pages/ksa/review/components/StepReviewComment';
import Section from '~/layouts/Section ';
import buildNamePath from '~/utils/buildNamePath';
import { KsaPerson } from '~/types/ksa/KsaPerson';
import PersonReviewFormItems from './components/PersonReviewFormItems';

const Managers: FC = () => {
  const { t } = useTranslation('ksaReview');

  const [form] = WizardForm.useForm();

  const payload = useGetPayload();
  const managers = payload?.managers;
  const managerCount = managers?.managers?.length;
  const managerFromProvided: KsaPerson | undefined = get(payload?.provided, managersGetFormName(0));
  const managerFromApplication: KsaPerson | undefined = get(payload, managersGetFormName(0));

  return (
    <Container className="Managers">
      {managerCount === 1 ? (
        <>
          <Typography.Title>{t('Managers')}</Typography.Title>
          <WizardForm<Draft<'reviewManagers'>>
            payloadKey="reviewManagers"
            form={form}
            stage={Stage.ksaReview}
          >
            <PersonReviewFormItems
              formItemsPath={reviewManagersGetFormName(0)}
              payloadReferencePath={managersGetFormName(0)}
              hasPassport={!!managerFromProvided?.passport?.documentNumber}
              hasPersonalDocument={!!managerFromProvided?.personalDocument?.idNumber}
              isSignedWithEmail={!!managerFromProvided?.personalData?.email}
              hasVerifiedPhoneNumber={
                !!managerFromProvided?.personalData?.phoneNumber ||
                !!managerFromApplication?.personalData?.phoneNumber
              }
            />
            <Section>
              <StepReviewComment n={buildNamePath(reviewManagersFormName)} />
            </Section>
          </WizardForm>
        </>
      ) : (
        <>
          <Typography.Title>{t('Managers')}</Typography.Title>
          <WizardForm<any> payloadKey="reviewManagers" form={form} stage={Stage.ksaReview}>
            <Form.Item name={[reviewManagersFormName]}>
              <ManagersReviewTableForm />
            </Form.Item>
            <Section>
              <StepReviewComment n={buildNamePath(reviewManagersFormName)} />
            </Section>
          </WizardForm>
        </>
      )}
    </Container>
  );
};

const Container = styled.div``;

export default Managers;
